import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SCREEN_TYPES } from '../breakpoint/custom-breakpoints';

@Component({
  selector: 'vfs-template-all-in-small',
  templateUrl: './template-all-in-small.component.html',
  styleUrls: ['./template-all-in-small.component.scss']
})
export class TemplateAllInSmallComponent {
  @Input() noPadding = false;
  @Input() border = false;
  @Input() container: string;
  @Input() routerOutlet = false;
  mode = 'default';

  protected destroyed = new Subject();

  constructor(protected breakpointObserver: BreakpointObserver) {
    // FIXME: This subscription is never close
    this.breakpointObserver
      .observe([SCREEN_TYPES.SMALL])
      .pipe(takeUntil(this.destroyed))
      .subscribe(result => {
        if (result.matches) {
          this.mode = 'small';
        } else {
          this.mode = 'default';
        }
      });
  }
}
